var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackerPreping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1,.prefix__cls-4{fill:none}.prefix__cls-1,.prefix__cls-2{stroke:#000}.prefix__cls-2{fill:#fff}.prefix__cls-3{stroke:none}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_360",
    "data-name": "Group 360",
    transform: "translate(-823 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_60",
    className: "prefix__cls-1",
    "data-name": "Ellipse 60",
    transform: "translate(823 861)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41,
    className: "prefix__cls-4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_140",
    d: "M5579.921-11981.249H5554v13.708",
    className: "prefix__cls-1",
    "data-name": "Path 140",
    transform: "translate(-4694.733 12884.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_141",
    d: "M5537-12001.026s5.567-1.077 9.518 5.388 9.57 8.672 17.78 8.8c.1-.026 5.542 0 5.542 0",
    className: "prefix__cls-1",
    "data-name": "Path 141",
    transform: "translate(-4687.191 12889.495)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_61",
    className: "prefix__cls-2",
    "data-name": "Ellipse 61",
    transform: "translate(844 888)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    className: "prefix__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_64",
    className: "prefix__cls-2",
    "data-name": "Ellipse 64",
    transform: "translate(846 890)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    className: "prefix__cls-4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerPreping);
export default __webpack_public_path__ + "static/media/tracker-preping.7ef9284edff8b26841f7e3c828305410.svg";
export { ForwardRef as ReactComponent };